<template>
  <ul>
    <li>{{ $t("training.program.duration") }}: {{ training.durationText }}</li>
    <li>{{ $t("training.program.modality") }}: {{ training.modality }}</li>
    <li>{{ $t("training.program.pace") }}: {{ training.pace }}</li>
    <li>{{ $t("training.program.location") }}: {{ training.location }}</li>
    <li>{{ $t("training.program.professionalOutcomes") }} : {{ training.professionalOutcomes }}</li>
  </ul>
</template>

<script>
export default {
  name: "TrainingProgramAccordionInformationsComponent",
  props: {
    training: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  line-height: 2;
  padding-left: 15px;
  margin-bottom: 0;

  @include dark-theme {
    color: $white;
  }
}
</style>
